export const getScreenPermissions = (screen) => {
  const create = !!screen?.create
  const update = !!screen?.update
  const del = !!screen?.delete
  const read = !!(screen?.read || create || update || del)

  return { read, create, update, delete: del }
}
